export const GAP_WIDTH = 10; // additional gap between slides (some is already there from the scaling)
export const DEFAULT_NEXT_SLIDE_THRESHOLD = 5; //distance in pixels needed to trigger a next slide
